import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import axios from "axios";
import "./index.css";
import tileIcon from "../../../../src/assets/images/tiles_icon.png"
import listIcon from "../../../../src/assets/images/list_icon.png"
import Search from "../../Elements/Search/Search";
import OptSearch from "../../Elements/OptSearch";
import OptSearch3 from "../../Elements/OptSearch3/OptSearch3";
import OptSearch4 from "../../Elements/OptSearch4/OptSearch4";
import OptSearch5 from "../../Elements/OptSearch5/OptSearch5";
import RightIconMenu from "../RightIconMenu";
import $ from "jquery";
import PaginationList from "../PaginationList";

export default class View_type_17 extends Component {
    constructor(props) {
        super(props);
        //console.log("View_type_17 ", props);
        var data = Array.isArray(props.data) ? props.data[0] : props.data;
        this.state = {
            data: data,
            r_menu: data.right_menu ? data.right_menu : [],
            r_menu_serach: data.right_menu_serach ? data.right_menu_serach : [],
            title: data.title ? data.title : "",
            tabs: data.tabs ? props.data.tabs : [],
            content: data.content ? data.content : [],
            read_more: data.read_more ? data.read_more : [],
            list: data.list ? data.list : [],
            content_title: data.content_title ? data.content_title : null,
            rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],
            pagination: [],
            search_content: [],
            itemsPerPage: 100,
            listCounter: 1,
            sortType: "title_asc"
        };
    }

    createMarkup(item) {
        return { __html: item };
    }

    inputHandler = e => {
        //console.log(e.target.value);
    };

    search_handler = (event) => {
        event.preventDefault();
        let data = new FormData(event.target);

        axios.post('/url', data)
            .then(function (response) {
                this.setState({
                    search_content: this.props.data.search_content,
                });
            })
            .catch(function (error) {
                //console.log(error);
            });
    }

    componentDidMount() {
        this.setState({
            search_content: this.props.data.search_content,
            pagination: this.props.data.pagination,
        });
    }

    sortUpdate = (e) => {
        this.setState({ sortType: e.currentTarget.value });
        //console.log(this.state.sortType);
    }



    render() {

        let selectLabel = window.location.href.indexOf("/en/") > -1 ? "choose" : "wybierz";
        let sortLabel1 = window.location.href.indexOf("/en/") > -1 ? "ascending" : "rosnąco";
        let sortLabel2 = window.location.href.indexOf("/en/") > -1 ? "descending" : "malejąco";

        const {
            // search_content,
            iconography_search,
            description,
            title_image,
            table,
            border_bottom
        } = this.props.data;

        $("#tile-btn").click(function () {
            //console.log("kafelki");
            $(".iconography__search-list-wrapper").removeClass("list-view");
            $(".iconography__search-list-wrapper").addClass("tile-view");
            $("#list-btn").css("border", "1px solid white");
            $("#tile-btn").css("border", "1px solid red");
        })

        $("#list-btn").click(function () {
            //console.log("lista");
            $(".iconography__search-list-wrapper").addClass("list-view");
            $(".iconography__search-list-wrapper").removeClass("tile-view");
            $("#tile-btn").css("border", "1px solid white");
            $("#list-btn").css("border", "1px solid red");
        })

        var _this = this;

        var var1 = this.state.data.title ? this.state.data.title : "";

        var calendar = this.state.calendar ? (
            <Link to={this.state.calendar.url}>
                <div className="vt2-calendar">
                    <img className="vt2-calendar-img" src={this.state.calendar.img} />
                    {this.state.calendar.text}
                </div>
            </Link>
        ) : null;

        let flex = null;

        if (this.props.data.list) {
            flex = {
                display: "flex",
                flexWrap: "wrap"
            };
        }
        let borderBottomClass = null;
        if (border_bottom) {
            borderBottomClass = {
                borderBottom: "2px solid #c1c1c1"
            };
        }
        let itemAmount = this.state.itemsPerPage * this.state.listCounter;

        const paginationList = this.state.data.pagination_list ? <PaginationList sortType={this.state.sortType} {...this.state.data} /> : null;

        let sort_label = window.location.href.indexOf("/en/") > -1 ? "Sort by" : "Sortuj po";

        return (
            <div className="vt2">
                <div className="vt2 left col-xs-12 col-sm-12 col-md-8 col-lg-9">
                    <div className="vt2 row">
                        <div className="vt2-title">
                            {this.props.data.border_bottom ? (
                                <div
                                    style={borderBottomClass}
                                    className="vt2-title-name vt14-title-name artists-pageTitle"
                                    dangerouslySetInnerHTML={{ __html: var1 }}
                                />
                            ) : (
                                <div
                                    className="vt2-title-name vt14-title-name artists-pageTitle"
                                    dangerouslySetInnerHTML={{ __html: var1 }}
                                />
                            )}

                            {title_image && (
                                <div className="vt14 title_image">
                                    {this.props.data.title_description && (
                                        <h2 className="vt14 title-image__description">
                                            {this.props.data.title_description}
                                        </h2>
                                    )}
                                    <img src={title_image} />
                                </div>
                            )}

                            <h2 aria-label="page title" className="vt14-content__title" dangerouslySetInnerHTML={{ __html: this.state.content_title }}>
                            </h2>
                            {iconography_search && (
                                <form id="search-form" onSubmit={this.search_handler}>
                                    <div className="row iconography-search">
                                        <div className="col-xs-12 iconography__title">Szukaj wg</div>
                                        <div className="search-section row">
                                            {this.state.search_content ?
                                                (this.state.search_content.map((elem, key) => {
                                                    if (this.state.search_content.length % 2 == 0) {
                                                        return (
                                                            <div
                                                                key={key}
                                                                className={
                                                                    `col-md-6 col-xs-12 iconography__box iconography__box--left--${key}`
                                                                }>
                                                                <label htmlFor={`search-field-${key}`}>{elem.value}</label>
                                                                <input type="text" id={`search-field-${key}`} name={elem.name} />

                                                            </div>
                                                        )

                                                    }
                                                    else {
                                                        return (
                                                            <div
                                                                key={key}
                                                                className={
                                                                    `col-md-6 col-xs-12 iconography__box iconography__box--left--${key}odd`
                                                                }>
                                                                <label htmlFor={`search-field-${key}`}>{elem.value}</label>
                                                                <input type="text" id={`search-field-${key}`} />

                                                            </div>
                                                        )
                                                    }

                                                }

                                                ))
                                                :
                                                (null)
                                            }

                                        </div>
                                        <div className="col-xs-12 iconography__btn">
                                            <button className="iconography-search--btn">Szukaj</button>
                                        </div>
                                    </div>
                                </form>
                            )}

                            <div className="vt2-title-tabs">
                                {this.state.tabs.map(function (object, i) {
                                    if (object.active === 1) {
                                        return (
                                            <div
                                                className="vt2 col-xs-6 col-sm-6 col-md-6 col-lg-6"
                                                key={i}
                                            >
                                                <div className="vt2 tab-checked">
                                                    <Link to={"/" + object.link}>{object.title}</Link>
                                                </div>
                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div
                                                className="vt2 col-xs-6 col-sm-6 col-md-6 col-lg-6"
                                                key={i}
                                            >
                                                <Link to={"/" + object.link}>{object.title}</Link>
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </div>
                        {
                            this.state.data.optional_search_area ?
                                (<OptSearch />)
                                :
                                (null)
                        }
                        {
                            this.state.data.optional_search_area3 ?
                                (<OptSearch3 {...this.state.data} />)
                                :
                                (null)
                        }
                        {
                            this.state.data.optional_search_area4 ?
                                (<OptSearch4 {...this.state.data} />)
                                :
                                (null)
                        }
                        {
                            this.state.data.optional_search_area5 ?
                                (<OptSearch5 {...this.state.data} />)
                                :
                                (null)
                        }
                        <div className="vt2-content">
                            {this.state.data.switch_text ?
                                (
                                    <div className="iconography__search-wrapper iconography__search-wrapper--grid ">
                                        <div>
                                            <p style={{ paddingTop: "5px", margin: '0', display: 'inline-block' }}>{this.state.data.switch_text}</p>
                                            <button className="iconography__text" id="tile-btn">
                                                <img src={tileIcon} aria-label="tile icon" />
                                                {this.state.data.switch_tilies_text ? <span className="link-name">{this.state.data.switch_tilies_text}</span> : null}
                                            </button>
                                            <button className="iconography__text" id="list-btn" style={{ border: "1px solid red" }} >
                                                <img src={listIcon} aria-label="list icon" />
                                                {this.state.data.switch_list_text ? <span className="link-name">{this.state.data.switch_list_text}</span> : null}
                                            </button>
                                        </div>
                                        <div>
                                            {this.state.data.column_1 && this.state.data.column_2 && this.state.data.column_3 && this.state.data.column_4 ? (
                                                <div className="custom-sort-section test5">
                                                    <p>{sort_label}</p>
                                                    <select name="sortType" id="sortType" onChange={this.sortUpdate}>
                                                        {this.props.data.sort_list.map((item, index) => {
                                                            return (<option key={index} value={item.sort}>{item.text}</option>)
                                                        })}
                                                    </select>
                                                </div>
                                            ) : null}
                                        </div>

                                    </div>
                                ) : (
                                    // <div className="iconography__search-wrapper iconography__search-wrapper--grid ">
                                    // 	<div></div>
                                    // 	<div>
                                    // 		{this.state.data.column_1 && this.state.data.column_2 && this.state.data.column_3 && this.state.data.column_4 ? (
                                    // 			<div className="custom-sort-section test6">
                                    // 				<p>{sort_label}</p>
                                    // 				<select onChange={this.sort}>
                                    // 					<option value="false" disabled selected>{selectLabel}</option>
                                    // 					<option value="column_1">{this.state.data.column_1}</option>
                                    // 					<option value="column_2">{this.state.data.column_2}</option>
                                    // 					<option value="column_3">{this.state.data.column_3}</option>
                                    // 					<option value="column_4">{this.state.data.column_4}</option>
                                    // 				</select>
                                    // 				<select onChange={this.sortOrder}>
                                    // 					<option value="asc" >{sortLabel1}</option>
                                    // 					<option value="desc">{sortLabel2}</option>
                                    // 				</select>
                                    // 			</div>
                                    // 		) : null}
                                    // 	</div>

                                    // </div>
                                    <div />
                                )}

                            <div dangerouslySetInnerHTML={_this.createMarkup(this.state.content)} />
                        </div>
                        <div>
                            {!this.props.data.content &&
                                !this.props.data.single_list_content &&
                                !this.props.data.iconography_search_list ? (
                                <div style={flex} className="vt17 iconography__wrapper">
                                    <p
                                        style={{
                                            width: "100%",
                                            textAlign: "left"
                                        }}
                                    >
                                        Kolekcje
                                    </p>{" "}
                                    {this.state.data.list.map(function (object, i) {
                                        if (object.cols == 3) {
                                            var color = "rgba(0,156,178,0.5)";

                                            if (
                                                object !== "undefined" &&
                                                object.hasOwnProperty("img") &&
                                                !object.hasOwnProperty("text")
                                            ) {
                                                var img = object.img;
                                                var thumbnail = (
                                                    <div
                                                        style={{
                                                            flex: 1,
                                                            backgroundColor: color,
                                                            padding: 10,
                                                            color: "white",
                                                            position: "absolute",
                                                            left: 15,
                                                            right: 15
                                                        }}
                                                    >
                                                        {object.title}
                                                    </div>
                                                );
                                                return (
                                                    <div
                                                        className="vt2 col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                                        key={i}
                                                    >
                                                        <div>
                                                            {thumbnail}
                                                            <img src={img} className="vt2 list_image" />
                                                        </div>
                                                    </div>
                                                );
                                            } else if (object !== "undefined") {
                                                var button = null;
                                                var img = object.img;
                                                var thumbnail = (
                                                    <div
                                                        className="vt2 middle-thumbnailholder"
                                                        style={{
                                                            flex: 1,
                                                            backgroundColor: color,
                                                            padding: 10,
                                                            color: "white"
                                                        }}
                                                    >
                                                        {object.title}
                                                    </div>
                                                );
                                                var img = (
                                                    <div>
                                                        <img src={img} />
                                                    </div>
                                                );

                                                if (typeof object.button !== "undefined") {
                                                    button = (
                                                        <div className="vt2 middle-addelem middle-addelem--iconography">
                                                            <Link
                                                                to={object.button.link}
                                                                className="vt2 more_button"
                                                            >
                                                                {" "}
                                                            </Link>
                                                        </div>
                                                    );
                                                }
                                                if (i == 0) {
                                                    return (
                                                        <div
                                                            className="vt2-col vt2-col--playlist col-xs-6 col-sm-4 col-md-4 col-lg-4 text-center"
                                                            key={i}
                                                        >
                                                            <div className="vt2 row">
                                                                <div className="vt2 middle-postblock middle-postblock--box">
                                                                    {img}
                                                                </div>
                                                                <div>
                                                                    <Link to={object.button.link}>
                                                                        <div
                                                                            className="ChopinLists__text-button"
                                                                            dangerouslySetInnerHTML={_this.createMarkup(
                                                                                object.text
                                                                            )}
                                                                        />
                                                                    </Link>
                                                                    {button}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                } else {
                                                    return (
                                                        <div
                                                            className="vt2-col vt2-col--playlist col-xs-6 col-sm-4 col-md-4 col-lg-4 text-center"
                                                            key={i}
                                                        >
                                                            <div className="vt2 row">
                                                                <div className="vt2 middle-postblock middle-postblock--box ">
                                                                    {img}
                                                                </div>
                                                                <div>
                                                                    <Link to={object.button.link}>
                                                                        <div
                                                                            className="ChopinLists__text-button"
                                                                            dangerouslySetInnerHTML={_this.createMarkup(
                                                                                object.text
                                                                            )}
                                                                        />
                                                                    </Link>
                                                                    {button}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            }
                                        } else {
                                            var color = "rgba(0,156,178,0.5)";

                                            if (
                                                object !== "undefined" &&
                                                object.hasOwnProperty("img") &&
                                                !object.hasOwnProperty("text")
                                            ) {
                                                var img = object.img;
                                                var thumbnail = (
                                                    <div
                                                        style={{
                                                            flex: 1,
                                                            backgroundColor: color,
                                                            padding: 10,
                                                            color: "white",
                                                            position: "absolute",
                                                            left: 15,
                                                            right: 15
                                                        }}
                                                    >
                                                        {object.title}
                                                    </div>
                                                );
                                                return (
                                                    <div
                                                        className="vt2 col-xs-12 col-sm-12 col-md-12 col-lg-12"
                                                        key={i}
                                                    >
                                                        <div>
                                                            {thumbnail}
                                                            <img src={img} className="vt2 list_image" />
                                                        </div>
                                                    </div>
                                                );
                                            } else if (object !== "undefined") {
                                                var button = null;
                                                var img = object.img;
                                                var thumbnail = (
                                                    <div
                                                        className="vt2 middle-thumbnailholder"
                                                        style={{
                                                            flex: 1,
                                                            backgroundColor: color,
                                                            padding: 10,
                                                            color: "white"
                                                        }}
                                                    >
                                                        {object.title}
                                                    </div>
                                                );
                                                var img = (
                                                    <div>
                                                        <img src={img} />
                                                    </div>
                                                );

                                                if (typeof object.button !== "undefined") {
                                                    button = (
                                                        <div className="vt2 middle-addelem  middle-addelem--iconography">
                                                            <Link
                                                                to={object.button.link}
                                                                className="vt2 more_button"
                                                            >
                                                                {" "}
                                                            </Link>
                                                        </div>
                                                    );
                                                }
                                                //
                                                if (i == 0) {
                                                    return (
                                                        <div
                                                            className="vt2-col col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center"
                                                            key={i}
                                                        >
                                                            <div className="vt2 middle-postblock">
                                                                {img}
                                                                <div
                                                                    dangerouslySetInnerHTML={_this.createMarkup(
                                                                        object.text
                                                                    )}
                                                                />
                                                                {button}
                                                            </div>
                                                        </div>
                                                    );
                                                } else {
                                                    return (
                                                        <div
                                                            className="vt2-col col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center"
                                                            key={i}
                                                        >
                                                            <div className="vt2 middle-postblock">
                                                                {img}
                                                                <div
                                                                    dangerouslySetInnerHTML={_this.createMarkup(
                                                                        object.text
                                                                    )}
                                                                />
                                                                {button}
                                                            </div>
                                                        </div>
                                                    );
                                                }

                                                //
                                            }
                                        }
                                    })}
                                </div>
                            ) : null}
                            {this.state.pagination &&
                                this.props.data.iconography_search_list && (
                                    <div className="pagination pagination--search">
                                        <ul className="pagination__wrapper">
                                            <span>Strona</span>
                                            {this.state.pagination.map((elem, index) => {
                                                return (
                                                    <li key={index} className="pagination__item">
                                                        <NavLink
                                                            exact
                                                            activeClassName="pagination__selected"
                                                            to={elem.url}
                                                        >
                                                            {elem.id}
                                                        </NavLink>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                )}
                            {this.props.data.iconography_search_list && (
                                <div className="iconography__search-list-wrapper list-view">
                                    {!this.state.data.switch_text && (this.state.data.column_0 || this.state.data.column_1 || this.state.data.column_2 || this.state.data.column_3 || this.state.data.column_4) ? (
                                        <div className="iconography__search-wrapper--grid">
                                            <div></div>
                                            <div className="custom-sort-section test7">
                                                <p>{sort_label}</p>
                                                {/* <select onChange={this.sort}>
													<option value="false" disabled selected>{selectLabel}</option>
													{this.state.data.column_0 ? <option value="column_0">{this.state.data.column_0}</option> : null}
													{this.state.data.column_1 ? <option value="column_1">{this.state.data.column_1}</option> : null}
													{this.state.data.column_2 ? <option value="column_2">{this.state.data.column_2}</option> : null}
													{this.state.data.column_3 ? <option value="column_3">{this.state.data.column_3}</option> : null}
													{this.state.data.column_4 ? <option value="column_4">{this.state.data.column_4}</option> : null}
												</select>
												<select onChange={this.sortOrder}>
													<option value="asc" >{sortLabel1}</option>
													<option value="desc">{sortLabel2}</option>
												</select> */}
                                                <select name="sortType" id="sortType" onChange={this.sortUpdate}>
                                                    {this.props.data.sort_list.map((item, index) => {
                                                        return (<option key={index} value={item.sort}>{item.text}</option>)
                                                    })}
                                                </select>
                                            </div>
                                        </div>

                                    ) : null}
                                    <div className="row row__title" style={{ textAlign: "left" }}>
                                        {this.state.data.column_0 ? (
                                            <div className="col-lg-1 iconography__header">{this.state.data.column_0}</div>
                                        ) : null}
                                        <div className={`col-lg-3 iconography__header ${this.state.sortedBy == "column_1" ? "active" : ""}`}>{this.state.data.column_1}</div>
                                        <div className={`col-lg-3 iconography__header ${this.state.sortedBy == "column_2" ? "active" : ""}`}>{this.state.data.column_2}</div>
                                        <div className={`col-lg-2 iconography__header ${this.state.sortedBy == "column_3" ? "active" : ""}`}>{this.state.data.column_3}</div>
                                        <div className={`col-lg-3 iconography__header ${this.state.sortedBy == "column_4" ? "active" : ""}`}>{this.state.data.column_4}</div>
                                    </div>
                                    {paginationList}
                                    {/* {console.log("paginationList", paginationList)} */}
                                </div>
                            )}
                        </div>
                        {this.state.pagination && (
                            <div className="pagination">
                                <ul className="pagination__wrapper">
                                    {this.state.pagination.map((elem, index) => {
                                        return (
                                            <li key={index} className="pagination__item">
                                                <NavLink
                                                    exact
                                                    activeClassName="pagination__selected"
                                                    to={elem.url}
                                                >
                                                    {elem.id}
                                                </NavLink>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>
                <div className="vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3">
                    {this.state.r_menu.length > 2 ? (
                        <div className="vt2 RightMenu">
                            <ul className="vt2 right_menu_items">
                                {this.state.r_menu.map(function (object, i) {
                                    var var4 = object.url ? object.url : "";
                                    var var5 = object.name ? object.name : "";
                                    //console.log("RightMenu", object);
                                    return (
                                        <li className="vt2 left-menuItem" key={i}>
                                            <Link className="vt2 left-menuUnit" to={"/" + var4}>
                                                {var5}
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    ) : (
                        <div className="vt2 RightMenu vt14 RightMenu">
                            {this.props.data.right_menu_serach_option && (
                                <div>
                                    <span className="vt14 RightMenu__serach-title">
                                        szukaj wg:
                                    </span>
                                    <label className="vt14 RightMenu__serach-label">
                                        <p>Tytuł</p>
                                        <input
                                            className="vt14 RightMenu__serach-input"
                                            type="text"
                                        />
                                    </label>
                                    <ul className="vt2 right_menu_items RightMenu list">
                                        {this.state.r_menu_serach.map(function (object, i) {
                                            var var4 = object.url ? object.url : "";
                                            var var5 = object.name ? object.name : "";
                                            return (
                                                <li className="vt2 RightMenu item" key={i}>
                                                    <Link to={"/" + var4}>{var5}</Link>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            )}
                            {this.props.data.right_menu_serach_option_input && (
                                <Search inputHandler={this.inputHandler} {...this.props} />
                            )}
                            {this.state.rightIconMenu &&
                                <RightIconMenu data={this.state.rightIconMenu} />
                            }
                            {this.state.pagination && (
                                <ul className="vt2 right_menu_items RightMenu list">
                                    {this.state.pagination.map(function (object, i) {
                                        var var4 = object.url ? object.url : "";
                                        var var5 = object.name ? object.name : "";
                                        //console.log("RightMenu", object);
                                        return (
                                            <li className="vt2 RightMenu item" key={i}>
                                                <Link to={"/" + var4}>{var5}</Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_17/index.js